// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1880f60c","732":"437e60b1","977":"e5dbac36"}[chunkId] + ".chunk.js";
};